import { Button, Grid, useTheme } from '@mui/material';
import { useState } from 'react';
import ESIMDetails from './eSimDetails';
import SimoSimTypeSelector from './simoSimTypeSelector';
import styles from './style';

const SimoSimTypeContainer = ({ cmsData, continueButtonAction, cart }) => {
  const theme = useTheme();
  const [selectedType, setSelectedType] = useState(null);

  const mobileOffers = cart.offers.filter(offer => offer.baseOffer?.serviceGroup === 'MOBILE');
  const latestMobileOffer = mobileOffers[mobileOffers.length - 1];
  const offerId = latestMobileOffer?.id;

  return (
    <Grid
      container
      sx={{ display: 'flex', flexDirection: 'column', marginBottom: '100px', px: { xs: 3, sm: 4 } }}
    >
      <SimoSimTypeSelector
        onSelectType={setSelectedType}
        cmsData={cmsData}
        cart={cart}
        offerId={offerId}
      />
      {selectedType === 'ESIM' && <ESIMDetails cmsData={cmsData} cart={cart} offerId={offerId} />}
      <Grid item sx={styles(theme).continueCtaContainer}>
        <Button
          variant='buttonMedium'
          sx={selectedType ? styles(theme).confirmCTA : styles(theme).confirmCTADisabled}
          onClick={continueButtonAction}
        >
          Continue
        </Button>
      </Grid>
    </Grid>
  );
};
export default SimoSimTypeContainer;
